import React from 'react';
import Card from './Card';

const CardList = ({robots, setTest, onRouteChange, onRatingSubmitted }) => {
  return (
    <div>
      {
        robots.map((user, i) =>{
          return (
            <Card
              onRouteChange={onRouteChange} 
              setTest={setTest}
              onRatingSubmitted={onRatingSubmitted}
              key={i} 
              id={robots[i].id} 
              first_name={robots[i].first_name}
              last_name={robots[i].last_name} 
              gender={robots[i].gender}
              email={robots[i].email}
              rating={robots[i].rating}
              image_key={robots[i].image_key}
              rating_count={robots[i].rating_count}
              reported={robots[i].reported}
              administrator={robots[i].administrator}
            />
          );
        })
      }
    </div>
  );
}
export default CardList;